import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import s from "./style.module.css";
import { Button, Modal, Card, Row, Col } from "react-bootstrap";

const LastActivityModal = ({
    title = "Activity Details",
    activities = [], // Array of activity details
    show,
    handleModalHide,
    keyboard = false,
    backdrop = false,
    prevButtonText='Previous',
    nextButtonText='Next',
    finalButtonText='Proceed'
}) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Move to the next activity
    const handleNext = () => {
        if (currentIndex < activities.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    // Move to the previous activity
    const handlePrevious = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    const currentActivity = activities[currentIndex];

    return (
        <Fragment>
            <Modal
                animation={false}
                show={show}
                onHide={handleModalHide}
                keyboard={keyboard ? false : true}
                backdrop={backdrop ? "static" : true}
                scrollable
                dialogClassName="modal-lg"
                centered
                style={{ marginTop: '50px' }}
            >
                <Modal.Header closeButton={false}>
                    <Modal.Title style={{ fontSize: '18px' }}>{title}</Modal.Title>
                </Modal.Header>
                {console.log("Current",currentActivity)}
                <Modal.Body style={{ textAlign: 'center', maxHeight: '60vh', overflowY: 'auto' }}>
                <Card className="border-0 w-100">
                        <Card.Body>
                            {currentActivity.activity_date && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                        Meeting Date:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple',textAlign: 'left' }}>{currentActivity.activity_date}</Col>
                                </Row>
                            )}
                            {currentActivity.project_type_name && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                    Project Type:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple',textAlign: 'left'  }}>{currentActivity.project_type_name}</Col>
                                </Row>
                            )}
                            {currentActivity.activity_type && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                    Activity Type:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.activity_type}</Col>
                                </Row>
                            )}
                            {currentActivity.sub_activity_type && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                    Sub Activity Type:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.sub_activity_type}</Col>
                                </Row>
                            )}
                            
                            {currentActivity.assigned_to_name && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                    Meeting done by:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple',textAlign: 'left'  }}>{currentActivity.assigned_to_name}</Col>
                                </Row>
                            )}
                            {currentActivity.purpose_of_visit && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                        Purpose of Visit:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.purpose_of_visit}</Col>
                                </Row>
                            )}
                            {currentActivity.reason && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                        Reason:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.reason}</Col>
                                </Row>
                            )}
                            {currentActivity.introduction && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                        Introduction:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.introduction}</Col>
                                </Row>
                            )}
                            {currentActivity.product && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                        Product:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.product}</Col>
                                </Row>
                            )}
                            {currentActivity.serviceId && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                        Service:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.serviceId}</Col>
                                </Row>
                            )}
                            {currentActivity.solutionId && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                        Solution:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple',textAlign: 'left'  }}>{currentActivity.solutionId}</Col>
                                </Row>
                            )}
                            {currentActivity.description && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                        Description:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple',textAlign: 'left'  }}>{currentActivity.description}</Col>
                                </Row>
                            )}
                            {currentActivity.tagged_along_name && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                        Tag along Name:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple',textAlign: 'left'  }}>{currentActivity.tagged_along_name}</Col>
                                </Row>
                            )}
                            {currentActivity.meeting_outcome && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                        Meeting Outcome:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.meeting_outcome}</Col>
                                </Row>
                            )}
                            {currentActivity.mom && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                    MOM:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.mom}</Col>
                                </Row>
                            )}
                            {currentActivity.remark && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                    Remarks:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.remark}</Col>
                                </Row>
                            )}
                            {currentActivity.valet_client_mom && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                    Client MOM:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.valet_client_mom}</Col>
                                </Row>
                            )}
                            {currentActivity.comment && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                    Comment:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.comment}</Col>
                                </Row>
                            )}
                            {currentActivity.internal_mom && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                    Internal MOM:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.internal_mom}</Col>
                                </Row>
                            )}
                            {currentActivity.payment_collection_mom && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                    Payment Collection MOM:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.payment_collection_mom}</Col>
                                </Row>
                            )}
                            {currentActivity.relationship_meeting_mom && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                    Relationship Meeting MOM:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.relationship_meeting_mom}</Col>
                                </Row>
                            )}
                            {currentActivity.meeting_mom && (
                                <Row className="my-2">
                                    <Col xs={5} className="text-end fw-bold pe-3" style={{ color: 'black', fontWeight: 'bold', textAlign: 'right' }}>
                                    Meeting MOM:
                                    </Col>
                                    <Col xs={7} className="text-start" style={{ color: 'purple' ,textAlign: 'left' }}>{currentActivity.meeting_mom}</Col>
                                </Row>
                            )}
                        </Card.Body>
                    </Card>
                </Modal.Body>

                <Modal.Footer>
                    {/* Show Previous button only if not on the first item */}
                    {currentIndex > 0 && (
                        <Button className="btn-sm" variant="secondary" onClick={handlePrevious}>
                            {prevButtonText}
                        </Button>
                    )}
                    {/* Show Next button only if not on the last item */}
                    {currentIndex < activities.length - 1 && (
                        <Button className="btn-sm" variant="primary" onClick={handleNext}>
                            {nextButtonText}
                        </Button>
                    )}
                    {/* Show Close button only when viewing the last activity */}
                    {currentIndex === activities.length - 1 && (
                        <Button className="btn-sm" variant="primary" onClick={handleModalHide}>
                            {finalButtonText}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

LastActivityModal.propTypes = {
    show: PropTypes.bool,
    activities: PropTypes.array // Array of MOMs
};

export default LastActivityModal;
